import axios from 'axios';
import {
  IStock,
  IStockCollection,
  IStockListParams,
  ICreateStockPayload,
  IDeleteStockPayload,
  IUpdateStockPayload,
} from 'entities/Stock/Stock.models';

const basePath = 'stock';

export const stockTransport = {
  get: (params: IStockListParams): Promise<IStockCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<IStock> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateStockPayload): Promise<IStock> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateStockPayload): Promise<IStock> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteStockPayload): Promise<IStock> => axios.delete(`${basePath}`, { data: payload }),
};
